<template>
  <div class="wf-product-display-controls px-2">
    <div v-if="showSizeControl" class="wf-product-display-control wf-product-display-control-filter">
      <button
        class="wf-side-collapse-button wf-side-collapse-button-open btn"
        type="button" data-wf-collapse-target="#filters-side-collapse"
      >
        <span class="pr-3">{{ $resourceString['product.Search.Filters.Button.Show'] }}</span>
        <span class="png-icon png-icon-icons-glyph--k-sort-filter m-0" />
      </button>
    </div>

    <div class="wf-product-display-control wf-product-display-control-view-type">
      <div class="wf-toggle-switch wf-toggle-switch-mobile  shadow-none bg-white form-control">
        <input
          type="radio" name="product-display-view-type" value="room"
          id="product-display-view-type-room" @change="setViewMode" :checked="viewMode == 'room'"
        >
        <label for="product-display-view-type-room">
          {{ $resourceString["product.search.display.room.view"] }}
        </label>

        <div class="wf-toggle-switch-indicator" />

        <input
          type="radio" name="product-display-view-type" value="swatch"
          id="product-display-view-type-swatch" @change="setViewMode" :checked="viewMode == 'swatch'"
        >
        <label for="product-display-view-type-swatch">
          {{ $resourceString["product.search.display.swatch.view"] }}
        </label>
      </div>
    </div>

    <div class="no-gutters ml-4 dropdown-underline">
      <span class="text-muted text-uppercase text-size-small font-16 pt-1 text-nowrap">
        {{ $resourceString["common.accounts.Title.Sort"] }}:
      </span>
      <select
        id="dropdown"
        class="font-16 border-0 cursor-pointer custom-dropdown"
        @change="setSortOrder"
      >
      <option value="SellingStyleName asc" :selected="isAscendingOrder === 'asc' && (sortOrder  === 'SellingStyleName' || sortOrder[0] === 'SellingStyleName')">
          {{ $resourceString["product.search.display.sort.by.alphabet"] }}
        </option>
        <option value="SellingStyleName desc" :selected="isAscendingOrder === 'desc' && (sortOrder === 'SellingStyleName' || sortOrder[0] === 'SellingStyleName')">
          {{ $resourceString["product.search.display.sort.by.za"] }}
        </option>
        <option value="OriginalActivationDate desc" :selected="isAscendingOrder === 'desc' && sortOrder === 'OriginalActivationDate'">
          {{ $resourceString["product.search.display.sort.by.recent"] }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2';
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    showSizeControl: {
      type: Boolean,
      default: true
    },
    showSortControl: {
      type: Boolean,
      default: true
    },
  },
  components: {
		Icon,
	},
  data(){
    return{
      isSelected(option) {
        return this.selectedFilters['Collection']?.includes(option);
      },
    }
  },
  computed: {
    ...mapGetters({
      filters: 'filters/filters',
      selectedFilters: 'filters/selectedFilters',
      items: 'productDisplay/items',
      viewMode: 'filters/viewMode',
      tileSize: 'filters/tileSize',
      sortOrder: 'filters/sortOrder',
      isAscendingOrder: 'filters/isAscendingOrder',
    }),
    collectionFilter(){
      return this.filters.find(element => element.azureFilterName === 'Collection');
    }
  },
  methods: {
    ...mapActions({
      onFilterClick: 'filters/onFilterClick',
    }),
    setViewMode: function(e) {
      if (e.target.checked) {
        this.$store.dispatch('filters/setViewMode', e.target.value);
      }
    },
    setTileSize: function(e) {
      this.$store.dispatch('filters/setTileSize', e.target.value);
    },
    setSortOrder: function(e) {
      this.$store.dispatch('filters/setSortOrder', e.target.value);
    },
  },
};
</script>
